import type { Components, Theme } from "@mui/material/styles";

export const MuiPickersCalendarHeader: NonNullable<
  Components<Theme>["MuiPickersCalendarHeader"]
> = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingLeft: "1rem",
      paddingRight: "0.5rem",
      marginTop: "0.5rem",
      marginBottom: "0.5rem",
      color: theme.vars!.palette.rmh.text.primary,
    }),
    label: ({ theme }) => ({
      ...theme.typography.bodyMdMedium,
    }),
    switchViewButton: ({ theme }) => ({
      color: theme.vars!.palette.rmh.text.primary,
    }),
  },
};
